import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function unicodeFlag(countryCode: string | undefined) {
  if (!countryCode) {
    return ''
  }
  // eslint-disable-next-line no-restricted-globals -- regional-indicator emojis require String.fromCodePoint (no lodash equivalent)
  return countryCode?.toUpperCase?.()?.replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
}
